import PublicPolicyPage from '../components/layout/PublicPolicyPage';

export default function CookiePolicyPage() {
  return <PublicPolicyPage pageKey="cookies" canonicalPath="/cookie-policy" />;
}
